import { AxiosRequestConfig } from 'axios';
import { DASHBOARD, FHQ } from '@rootCommon/constants/common';
import { AUTH, AUTH_ADMIN_PANEL, AUTH_CONTROL_PANEL } from '@rootCommon/constants/end-points';
import CrudRequest from '@rootCommon/services/crud-request';
import { AuthenticationResponse, AuthorizationResponse, Credentials } from '@rootTypes/auth';
import { IdType } from '@rootTypes/common';
import {
  FhqKioskAuthorizationRequest,
  FhqLaunchAuthorizationRequest,
  FhqRemoteAuthorizationRequest,
  FhqAuthorizationResponse,
} from '@rootTypes/fhq-auth';

class AuthorizationService {
  private authorization = async (credentials: Credentials, url: string): Promise<AuthorizationResponse> => {
    const res = await CrudRequest.post<AuthorizationResponse, Credentials>(url, credentials);

    return res.data;
  };

  private fhqAuthorization = async <T>(data: T, url: string, siteId?: IdType): Promise<FhqAuthorizationResponse> => {
    const config = siteId ? { params: { siteId } } as AxiosRequestConfig : undefined;

    const res = await CrudRequest.post<FhqAuthorizationResponse, T>(`${AUTH}/${FHQ}/${url}`, data, config);

    return res.data;
  };

  adminAuthorization = (credentials: Credentials) => this.authorization(credentials, AUTH_ADMIN_PANEL);

  controlAuthorization = (credentials: Credentials) => this.authorization(credentials, AUTH_CONTROL_PANEL);

  dashboardAuthentication = async (email: string): Promise<AuthenticationResponse> => {
    const res = await CrudRequest.post<AuthenticationResponse, { email: string }>(
      `${AUTH}/${DASHBOARD}/authentication`, { email },
    );

    return res.data;
  };

  dashboardAuthorization = (credentials: Credentials) => this.authorization(
    credentials, `${AUTH}/${DASHBOARD}/authorization`,
  );

  fhqAuthorizationKiosk = (data: FhqKioskAuthorizationRequest, siteId: IdType) => this.fhqAuthorization(
    data, 'kiosk-authorization', siteId,
  );

  fhqAuthorizationLaunch = (data: FhqLaunchAuthorizationRequest) => this.fhqAuthorization(data, 'launch');

  fhqAuthorizationRemote = (data: FhqRemoteAuthorizationRequest) => this.fhqAuthorization(data, 'remote-authorization');
}

export default new AuthorizationService();
